import React, { useEffect, useState } from "react";
import { useLocation } from "react-router";
import { useTag } from "../../Hooks";
function TagSeoEdit() {
  const { loadding, tags, getTag } = useTag();
  useEffect(() => {
    getTag();
  }, []);
  const [newTag, setNewTag] = useState([]);
  const [selected, setSelected] = useState(false);
  const form = [
    {
      label: "کلمات کلیدی سئو",
      key: "seo",
      keyName: "seoKeyword",
      input: "textarea",
    },
    {
      label: "توضیحات سئو",
      key: "seo",
      keyName: "seoDescription",
      input: "textarea",
    },
    {
      label: "تگ ها",
      key: "seo",
      keyName: "seoDescription",
      input: "select",
      effect: "Gettags",
    },
    // {
    //   label: "تگ های مجموعه",
    //   size: "col-md-3",
    //   classNames: "mt-2 js-select2",
    //   placeholder: "",
    //   name: "tags",
    //   input: "select",
    //   effect: "GetTags",
    //   multiple: true,
    //   selected: getTagsId(item.tags),
    //   value: getTagsId(item.tags),
    // },
  ];
  const location = useLocation();
  return (
    <div></div>
    // <div>
    //   <div className="card">
    //     <div className="card-body">
    //       <div>
    //         <label>کلمات کلیدی سئو</label>
    //         <textarea
    //           className="form-control"
    //           defaultValue={location.state.data.seo.seoKeyword}
    //         />
    //       </div>
    //       <div>
    //         <label>توضیحات کلیدی سئو</label>
    //         <textarea
    //           className="form-control"
    //           defaultValue={location.state.data.seo.seoDescription}
    //         />
    //       </div>
    //       <h4> تگ ها </h4>
    //       {tags &&
    //         tags.map((tag) => {
    //           return (
    //             <button
    //               className={tag.id in newTag ? "btn btn-danger" : "btn"}
    //               onClick={() => {
    //                 let myTags = [...newTag];
    //                 myTags.push(tag.id);
    //                 setNewTag(myTags);
    //               }}
    //             >
    //               {tag.name}
    //             </button>
    //           );
    //         })}
    //     </div>
    //   </div>
    // </div>
  );
}

export default TagSeoEdit;
